import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { addToCart as apiAdd, fetchCart, updateItem as apiUpdate, removeItem as apiRemove } from "@/lib/api";
import { toast } from "sonner";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [cartId, setCartId] = useState(() => localStorage.getItem("gfx_cart_id"));
  const [cart, setCart] = useState({ items: [], count: 0, subtotal: 0, currency: "USD" });
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (cartId) {
      fetchCart(cartId).then(setCart).catch(() => {});
    }
  }, [cartId]);

  const addItem = useCallback(async ({ quantity = 1 } = {}) => {
    setLoading(true);
    try {
      const data = await apiAdd({
        cart_id: cartId,
        product_id: "gripforce-x",
        quantity,
      });
      if (!cartId) {
        setCartId(data.cart_id);
        localStorage.setItem("gfx_cart_id", data.cart_id);
      }
      setCart(data);
      toast.success("Added to cart", { description: `${quantity}× added — total $${data.subtotal.toFixed(2)}` });
      setOpen(true);
    } catch (e) {
      toast.error("Could not add to cart");
    } finally {
      setLoading(false);
    }
  }, [cartId]);

  const updateQty = useCallback(async (itemId, qty) => {
    if (!cartId) return;
    const data = await apiUpdate(cartId, itemId, qty);
    setCart(data);
  }, [cartId]);

  const removeFromCart = useCallback(async (itemId) => {
    if (!cartId) return;
    const data = await apiRemove(cartId, itemId);
    setCart(data);
  }, [cartId]);

  return (
    <CartContext.Provider
      value={{ cart, addItem, updateQty, removeFromCart, open, setOpen, loading }}
    >
      {children}
    </CartContext.Provider>
  );
};
